import React from 'react';
import { Helmet } from 'react-helmet-async';
import manikchandLogo from '../../assets/images/manikchand_Logo.svg';

const AboutUsPageHelmet: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>About Namasteji Manikchand Pan Masala | Best Pan Masala Brand in India</title>
        <meta
          name='description'
          content='Discover the story behind Namasteji Manikchand Pan Masala, the most trusted and admired pan masala brand in India. Learn how the Manikchand Pan Masala Company blends tradition, purity, and innovation to deliver excellence in every pack.'
        />
        <meta
          name='keywords'
          content='
          Namasteji Manikchand Pan Masala,
          Manikchand Pan Masala brand,
          About Namasteji Pan Masala,
          Manikchand Pan Masala company,
          Best pan masala brand in India'
        />
        <link rel='canonical' href='https://globalmanikchand.in/about' />

        <meta
          property='og:title'
          content='About Namasteji Manikchand Pan Masala – Finest Quality & Tradition in Every Blend'
        />
        <meta
          property='og:description'
          content='Namasteji Manikchand Pan Masala is a legacy brand celebrated for authenticity, superior quality, and rich Indian taste. Explore our journey as the best pan masala brand in India, blending heritage with modern innovation.'
        />
        <meta property='og:image' content={window.location.origin + manikchandLogo} />
        <meta property='og:type' content='website' />
        <meta property='og:url' content='https://globalmanikchand.in/about' />
        <meta property='og:site_name' content='Namasteji Manikchand Pan Masala – Manikchand Pan Masala Brand' />
        <meta property='og:locale' content='en_IN' />

        {/* Twitter Card */}
        <meta name='twitter:card' content={window.location.origin + manikchandLogo} />
        <meta
          name='twitter:title'
          content='About Namasteji Manikchand Pan Masala – Finest Quality & Tradition in Every Blend'
        />
        <meta
          name='twitter:description'
          content='Namasteji Manikchand Pan Masala is a legacy brand celebrated for authenticity, superior quality, and rich Indian taste. Explore our journey as the best pan masala brand in India, blending heritage with modern innovation.'
        />
        <meta name='twitter:image' content={window.location.origin + manikchandLogo} />
        <meta name='twitter:site' content='@NamastejiManikchand' />
      </Helmet>
    </>
  );
};

export default AboutUsPageHelmet;
